import { constants } from '@stefna/quasar-pilot-core/src/lib/constants';

constants.DEFAULT_LOCATION = 1;
constants.DEFAULT_DELIVERY_METHOD = 1;
constants.DEFAULT_PAYMENT_METHOD = 1;
constants.CATEGORY_OFFER_ID = 8;

constants.SESSION_COOKIE_USER_ID = 'duosUserUid';
constants.SESSION_COOKIE_LOCATION_ID = 'duosLocationUid';

constants.LOCATIONS = [{
  name: 'Mosfellsbæ',
  address: 'Háholt 13-15',
  address2: '270 Mosfellsbæ',
  phoneNumber: '565 2525',
  image: '/images/loc1.jpeg',
  openingHours1: '10:00 - 20:30',
  orderUrl: '',
},
{
  name: 'Hafnarfirði',
  address: 'Flatahraun 5A',
  address2: '220 Hafnarfirði',
  phoneNumber: '565 2525',
  image: '/images/loc2.jpeg',
  openingHours1: '11:00 - 21:00',
  orderUrl: '',
},
];

export default constants;
